// extracted by mini-css-extract-plugin
export default {"wrapper":"JudgesList_wrapper__0ax8a"};